import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {

    connect(): void {

        const select = this.element as HTMLSelectElement;

        if ((select as any).tomselect) {
            return;
        }

        new TomSelect(select, {
            create: false,
            allowEmptyOption: true,
            dropdownParent: 'body',
            onDropdownOpen: function(dropdown: HTMLElement) {
                dropdown.style.zIndex = '9999';
            },
        });
    }

    disconnect(): void {

        const ts = (this.element as any).tomselect;

        if (ts) {
            ts.destroy();
        }
    }
}
